import { useCallback } from "react";
import Papa from "papaparse";
import { Columns } from "../../types/index";
import { Export } from "../../states/filteredArrayState";

const useCsvDownloader = () => {
  const downloadCsv = useCallback(
    (data: Array<Export>, headerArray: Array<Columns>, filename: string) => {
      const transformedData = data.map((obj) => Object.values(obj));

      const headers = headerArray.map((header: any) => header.columnId);
      // 現在の日時をYYYYMMDDHHMMSS形式で取得
      transformedData.unshift(headers);
      const now = new Date();
      //const jstOffset = 9 * 60; // UTC+9のオフセット（分）
      //now.setMinutes(now.getMinutes() + now.getTimezoneOffset() + jstOffset);
      // const timestamp = now.toISOString().replace(/[-:T]/g, "").slice(0, 14);
      const timestamp = formatDateForFilename(now);
      const fullname = `${filename}_${timestamp}.csv`;

      // CSVデータを変換
      const bom = "\uFEFF"; // BOMの追加
      const csv = bom + Papa.unparse(transformedData);
      // Blobを使ってCSVファイルを作成
      const csvFile = new Blob([csv], { type: "text/csv;charset=utf-8;" });
      // ダウンロード用のリンクを作成
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(csvFile);
      downloadLink.setAttribute("download", fullname);
      // リンクをクリックしてダウンロードを実行
      document.body.appendChild(downloadLink); // DOMにリンクを追加
      downloadLink.click(); // リンクをクリック
      document.body.removeChild(downloadLink); // リンクを削除
    },
    []
  );

  return { downloadCsv };
};

const formatDateForFilename = (date: any) => {
  if (!date) return "";

  const d = new Date(date);
  const year = d.getFullYear();
  const month = `0${d.getMonth() + 1}`.slice(-2);
  const day = `0${d.getDate()}`.slice(-2);
  const hour = `0${d.getHours()}`.slice(-2);
  const minute = `0${d.getMinutes()}`.slice(-2);
  const second = `0${d.getSeconds()}`.slice(-2);

  return `${year}${month}${day}_${hour}${minute}${second}`;
};

export default useCsvDownloader;
/*
data = [
  [
    { id: 1, name: "aaa", value: 20 },
    { id: 3, name: "b", value: 20 },
    { id: 2, name: "aaa", value: 20 },
  ],
  [
    { id: 1, name: "aaa", value: 20 },
    { id: 3, name: "daa", value: 40 },
    { id: 2, name: "aaa", value: 20 },
  ],
  [
    { id: 1, name: "ff", value: 40 },
    { id: 3, name: "aea", value: 20 },
    { id: 2, name: "aaa", value: 20 },
  ],
];
header = [{ columnId: "ID", isShow: true }];
input =[[{"ID":"11111" },{name:"maeda"}],[{"ID":"12345" },{name:"hayashi"}]]
output =[["11111","maeda"],[12345,"hayashi"]]
*/
